// Components==============
import { faArrowRight, faSignOut } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import updateTreatment from 'actions/treatment/update';
import retrieveUser from 'actions/authentication/retrieve';
import { motion } from 'framer-motion';
import React, { useContext, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { NavLink, useParams } from 'react-router-dom';
import { HomeworkContext } from 'screens/Homework/Homework';
import './FinishedButtons.module.scss';
// =========================

export default function HomeworkFinishedButtons() {
    const { homework, allHomework } = useContext(HomeworkContext);

    const dispatch = useDispatch();
    const { treatmentId } = useParams() as { treatmentId: string };

    const nextExercise = allHomework
        ?.filter((e) => e?.treatment_id === homework?.treatment_id)
        .find((e) => {
            if (e && homework) return e.id > homework.id;
            return null;
        });

    const finishTreatment = () => {
        if (!nextExercise) {
            dispatch(
                updateTreatment(treatmentId, {
                    markAsFinished: true,
                })
                // @ts-ignore
            ).then(() => dispatch(retrieveUser()));
        }
    };

    useEffect(() => finishTreatment(), []);

    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            styleName="wrapper"
        >
            {nextExercise ? (
                <>
                    <NavLink to="/">
                        <button type="button">
                            {' '}
                            <FontAwesomeIcon
                                styleName="sign-out"
                                icon={faSignOut}
                            />
                            Terug naar kaart
                        </button>
                    </NavLink>
                    <NavLink to={`/${treatmentId}/homework/${nextExercise.id}`}>
                        <button type="button">
                            Door naar spellingwerk 2{/* {nextExercise.id} */}
                            <FontAwesomeIcon icon={faArrowRight} />
                        </button>
                    </NavLink>
                </>
            ) : (
                <NavLink to="/">
                    <button type="button">
                        {' '}
                        <FontAwesomeIcon
                            styleName="sign-out"
                            icon={faSignOut}
                        />
                        Behandeling afronden
                    </button>
                </NavLink>
            )}
        </motion.div>
    );
}
